import * as React from "react";
import { useRef } from "react";
import "../../styles/base/label.scss";

interface FilterOrAddInputProps {
  className: string;
  name: string;
  placeholder: string;
  onCurrentFilterChange: (value) => void;
}

export default function FilterOrAddInput({
  className,
  name,
  placeholder,
  onCurrentFilterChange,
}: FilterOrAddInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const onKeyUp = () => {
    onCurrentFilterChange(inputRef?.current?.value);
  };

  return (
    <input
      type="text"
      ref={inputRef}
      className={className}
      name={name}
      placeholder={placeholder}
      onKeyUp={onKeyUp}
      onClick={(e) => e.stopPropagation()}
    />
  );
}
